package app.nestbridge

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import com.karawek.core.platform.WebPlatformContext
import app.nestbridge.app.di.AppComponent
import app.nestbridge.app.di.create
import app.nestbridge.app.monitoring.initializeSentry

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    initializeSentry(environment = "web")
    val appComponent = AppComponent::class.create(WebPlatformContext())

    ComposeViewport {
        appComponent.rootApp()
    }
}